import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';

import Nav from './Nav';
import Header from './Header';
import Footer from './Footer';
// import MobileNav from './MobileNav';

import { bpMaxSM, bpMaxMD, bpMaxLG } from '../utils/breakpoints';

const Container = styled.div`
	/* display: block; */
	max-width: 46rem;
	margin-left: auto;
	margin-right: auto;
	/* position: relative; */
	padding: 1.625rem 1.3125rem;

	${bpMaxLG} {
		display: grid;
		max-width: 60rem;
		grid-template-areas:
			'empty-header header'
			'nav main'
			'empty-footer footer';
		grid-template-rows: 40px;
		grid-template-columns: 230px;
		grid-gap: 30px;

		header {
			grid-area: header;
		}

		main {
			grid-area: main;
			max-width: calc(60rem - 230px);
		}

		aside {
			grid-area: nav;
		}

		footer {
			grid-area: footer;
		}
	}

	${bpMaxMD} {
		display: grid;
		grid-gap: 0px;
		max-width: 100%;
		grid-template-areas:
			'header'
			'nav'
			'main'
			'footer';
		grid-template-rows: 40px;
		grid-template-columns: 100%;
		/* grid-gap: 30px; */

		header {
			grid-area: header;
		}

		main {
			grid-area: main;
		}

		aside {
			grid-area: nav;
		}

		footer {
			grid-area: footer;
		}
	}

	${bpMaxSM} {
		display: block;
	}
`;

const Layout = ({ location, title, children }) => {
	const rootPath = `${__PATH_PREFIX__}/`;

	const data = useStaticQuery(graphql`
		query BioQuery {
			avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
				childImageSharp {
					fixed(width: 90, height: 90, quality: 100) {
						...GatsbyImageSharpFixed
					}
				}
			}
			site {
				siteMetadata {
					author {
						name
					}
				}
			}
		}
	`);

	return (
		<Container>
			<Header data={data} location={location} rootPath={rootPath} />
			<aside className="relative">
				<Nav data={data} location={location} />
			</aside>
			{/* <MobileNav location={location} /> */}
			<main className="py-6 lg:py-12 xl:py-16">{children}</main>
			<Footer />
		</Container>
	);
};

export default Layout;
